import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { AddExternalLinkResponse, AddExternalLinkPayload } from '../../common/types';

export const addExternalLink = (
	cloudId: string,
	payload: AddExternalLinkPayload,
): Promise<AddExternalLinkResponse> => {
	const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/`;

	return performPostRequest(uri, {
		body: JSON.stringify(payload),
	});
};
